let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bJLXg")).then(() => parcelRequire('1tBVE'));